module.exports = __webpack_public_path__ + "img/184cbd5.png";